<template>
  <div
    :style="`margin-left:${isFirstCol ? 10 : 45}px;position:relative`"
    :class="isEnable ? 'not-disabled' : 'disabled'"
  >
    <div :class="imgClass" @click="itemSelect">
      <a href="#">
        <img :src="url" style="clip-path: circle(50% at 50% 50%)" alt />
        <div
          v-if="!isEnable"
          class="zernike-btn"
          style="
            position: absolute;
            top: 0px;
            clip-path: circle(50% at 50% 50%);
            background: rgba(45, 48, 57, 0.97);
          "
        ></div>
      </a>
    </div>
    <p :class="isEnable ? 'not-disabled' : 'disabled'">
      {{ normalParam(zernikeVal) }}
    </p>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import EVENTS from "../../bus";
import { paramNormal } from "../../shared/filters";
import { zernikeIcons } from "../config/zernike";
let timeoutwait;
let timeoutwait2;
export default {
  name: "ZernikeIcon",
  data() {
    return {};
  },
  props: {
    order: {
      type: Number,
      default: 5
    },
    index: {
      type: Number,
      default: 0
    },
    value: {
      type: Boolean,
      default: false
    },
    zernikeVal: {
      type: Number,
      default: 0
    },
    enabled: {
      type: Boolean,
      default: true
    },
    isFirstCol: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    normalParam(v) {
      let val = paramNormal(v);
      return val === "-0.00" ? "0.00" : val;
    },
    itemSelect() {
      this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtLoading"));
      clearTimeout(timeoutwait);
      timeoutwait = setTimeout(() => {
        this.$bus.$emit(EVENTS.hideGlobalWatting);
      }, 5000);
      clearTimeout(timeoutwait2);
      timeoutwait2 = setTimeout(() => {
        this.$emit("input", !this.value);
      }, 300);
    }
  },
  computed: {
    ...mapGetters(["zernikeParams"]),
    url: function () {
      return zernikeIcons[this.index].src;
    },
    imgClass: function () {
      return "zernike-btn " + (this.value && this.isEnable ? "selected" : "not-selected");
    },
    isEnable: function () {
      return this.zernikeParams.params[this.index].enabled;
    }
  }
};
</script>
<style scoped>
img {
  width: 45px;
  height: 45px;
}

.zernike-btn {
  width: 50px;
  height: 50px;
}
.cover {
  width: 50px;
  height: 50px;
}
.selected {
  box-sizing: border-box;
  border-left: solid 2px gray;
  border-top: solid 2px gray;
  border-right: solid 2px white;
  border-bottom: solid 2px white;
}

p {
  width: 100%;
  text-align: center;
  line-height: 13px;
  padding: 10px 1px;
}
.not-selected {
  border: none;
}
.not-disabled {
  color: white;
}
.disabled {
  color: gray;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/ZernikeIcon.vue